export default __webpack_public_path__ + "static/media/poster_23_feb.9ea3ba4f.jpeg";